export const CONTACT = {
  phoneDisplay: "+351 927 158 692",
  phoneHref: "tel:+351927158692",
  email: "geral@megasolar.pt",
  emailHref: "mailto:geral@megasolar.pt",
  whatsappHref:
    "https://wa.me/351927158692?text=" +
    encodeURIComponent("Olá Mega Solar, gostaria de obter informações sobre uma solução de energia solar."),
};

export const NAV = [
  { to: "/", label: "Início" },
  { to: "/solucoes-residenciais", label: "Soluções Residenciais" },
  { to: "/solucoes-empresariais", label: "Soluções Empresariais" },
  { to: "/servicos", label: "Serviços" },
  { to: "/sobre-nos", label: "Sobre Nós" },
  { to: "/contactos", label: "Contactos" },
];

export const QUOTE_PATH = "/pedir-orcamento";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
  else el.scrollIntoView({ behavior: "smooth" });
};
